import React from 'react';
import moment from "moment";

import SpotlioIcon from '../../Icon';
import Currency from '../../Currency';

import Bundles from "./bundles";

import getDateFormat from "../../../utils/DateFormatRetriever";
import { getSystemSettings } from '../../../utils/SettingsRetriever';
import { getCartImage } from '../../../services/cart';

import IntlMessage from '../../../LocaleEngine';

export default function Cart(props){
    const { index, item, agrupation } = props;

    let bundleUpselling = true;
    if(getSystemSettings().app.bundles && getSystemSettings().app.bundles.enabledOnCart === false){
        bundleUpselling = false;
    }

    function getCurrency(displayType){
        let currency = null;
        switch (displayType){
            case 1:
                currency = (
                        <Currency displayType={displayType} strikeThrough={true} float={true} value={item.OriginalPrice} />
                )
            break;
            case 2:
                currency = (
                    <React.Fragment>
                        {(item.OriginalPrice > 0 && item.OriginalPrice > item.Price) ?<Currency displayType={displayType} strikeThrough={true} float={true} value={item.OriginalPrice} /> : null}
                        <Currency float={true} value={item.Price} />
                    </React.Fragment>
                )
            break;
            case 3:
            break;
            default:
            break;
        }
        return currency;
    }

    return (
        <React.Fragment>
            {
                window.innerWidth > 991
                ? <div className="cartItem">
                    <div key={"item"+index} className="product">
                        {
                            item.ReservationDate !== ''
                            ?
                            <div className="confirmed"><IntlMessage id="activities.cell.option.head.confirmed" /></div>
                            :
                            null
                        }
                        {   getCartImage(item) ?
                            <div className="multimedia noBackground" data-id={agrupation.id} data-supercategoryid={agrupation.supercategoryid} data-name={agrupation.name}>
                                <img src={getCartImage(item)} alt={item.SupplierName} />
                            </div>
                            : 
                            <div className="multimedia" data-id={agrupation.id} data-supercategoryid={agrupation.supercategoryid} data-name={agrupation.name}>
                            <SpotlioIcon icon={agrupation.icon} />
                            </div>
                        }
                        <div className="content">
                            <div className="supplierName">{item.SupplierName}</div>
                            <div className="productName">{item.ProductName}</div>
                            <div className="date"><span><IntlMessage id="cart.labels.arrival_date" />: </span>{moment.utc(item.ArrivalDate).format(getDateFormat())} <IntlMessage id="cart.labels.after" /> {item.StartTime}</div>
                            <div className="date"><span><IntlMessage id="cart.labels.departure_date" />: </span>{moment.utc(item.DepartureDate).format(getDateFormat())} <IntlMessage id="cart.labels.before" /> {item.EndTime}</div>
                            <div className="date">
                                <span>
                                    <IntlMessage id="cart.labels.adults" />: 
                                </span>
                                {" "}
                                {item.AdultCount}
                                {" "}
                                <span>
                                    <IntlMessage id="cart.labels.children" />: 
                                </span>
                                {" "}
                                {item.ChildCount} 
                                {item.ChildAges && 
                                    <React.Fragment>
                                        <strong> Ages: </strong>
                                        <span>{item.ChildAges}</span>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="qty"><span><IntlMessage id="cart.labels.quantity" />: </span>{item.Quantity}</div>
                        </div>
                        <div className="sideinfo">
                            <div className="price">
                                {item.PackageDisplayType ? getCurrency(item.PackageDisplayType) : <Currency float={true} value={item.Price}/>}
                                {item.PackageName ?
                                <React.Fragment>
                                    {item.OriginalPrice - item.Price > 0 ? 
                                        <div className="savings">
                                            <IntlMessage 
                                                id={
                                                    getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.savingsText 
                                                    ?
                                                    getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.savingsText
                                                    :
                                                    "cart.labels.savings"
                                                } />
                                            : <Currency float={true} onlyOriginal={true} value={parseFloat(item.OriginalPrice).toFixed(2) - parseFloat(item.Price).toFixed(2)}/></div> : null}
                                    {/* <p>{item.PackageName}</p> */}
                                </React.Fragment>
                                : null}
                            </div>
                            {item.PackageRequiredItem === 0 ?
                            <div onClick={() => props.deleteItem(item, true)} className="remove">
                                <SpotlioIcon size={16} icon={"feather-trash-2"} />
                                <span><IntlMessage id="cart.remove_item.buttons.remove" /></span>
                            </div>
                            :
                            <div className="required">
                                <SpotlioIcon size={16} icon={"feather-lock"} />
                                <span>Required component</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                : <div className="cartLodging">
                    <div className="lodgingTopContent">
                        <div className="lodgingImage" style={{backgroundImage: `url(${getCartImage(item)}`}} />
                        <div className="lodgingCaption">
                            <div className="destination">
                                {item.LocationName}
                            </div>
                            <div className="name">
                                {item.ProductName}
                            </div>
                        </div>
                    </div>
                    <div className="lodgingSumup">
                        <div className="sumup">
                            <div className="label">Check-in</div>
                            <div className="value">{moment.utc(item.ArrivalDate).format('ddd, D MMM YYYY')} <IntlMessage id="cart.labels.after" /> {item.StartTime}</div>
                        </div>
                        <div className="sumup">
                            <div className="label">Check-out</div>
                            <div className="value">{moment.utc(item.DepartureDate).format('ddd, D MMM YYYY')} <IntlMessage id="cart.labels.before" /> {item.EndTime}</div>
                        </div>
                        <div className="sumup">
                            <div className="label">Guests</div>
                            <div className="value">
                                {item.AdultCount} <IntlMessage id="cart.labels.adults" />
                                {item.ChildCount
                                ? <> - {item.ChildCount} <IntlMessage id="cart.labels.children" /></>
                                : null
                                }
                            </div>
                        </div>
                        <div className="sumup">
                            <div className="label"><IntlMessage id="cart.labels.quantity" /></div>
                            <div className="value">{item.Quantity}</div>
                        </div>
                        <div className="sumup">
                            {item.PackageRequiredItem === 0
                                ? <div className="deleteButton" onClick={() => props.deleteItem(item, true)}><SpotlioIcon icon="feather-trash"/></div>
                                : <div className="required"><SpotlioIcon size={16} icon={"feather-lock"} /> Required</div>
                            }
                            <div className="currency">
                                {item.PackageDisplayType ? getCurrency(item.PackageDisplayType) : <Currency float={true} value={item.Price}/>}
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                item.BundleRelationship && bundleUpselling ?
                <Bundles readOnly={props.readOnly} getBundle={props.getBundle} bundleConfig={props.bundleConfig} bundles={item.BundleRelationship} />
                :
                null
            }
        </React.Fragment>
    )
}
